module.exports = __webpack_public_path__ + "img/DE9261_86361E_A85A37_944C2C-256px.768c1e8c.png";